// Basic components
import Accordion from '../accordion/theme'
import Avatar from '../avatar/theme'
import Badge from '../badge/theme'
import Box from '../box/theme'
import Breadcrumbs from '../breadcrumbs/theme'
import Button from '../button/theme'
import Calendar from '../calendar/theme'
import Card from '../card/theme'
import Chat from '../chat/theme'
import Checkbox from '../checkbox/theme'
import DatePicker from '../datePicker/theme'
import Definition from '../definition/theme'
import Dialog from '../dialog/theme'
import DismissButton from '../dismissButton/theme'
import Display from '../display/theme'
import Divider from '../divider/theme'
import DragAndDrop from '../dragAndDrop/theme'
import Drawer from '../drawer/theme'
import Footer from '../footer/theme'
import Grid from '../grid/theme'
import Header from '../header/theme'
import Heading from '../heading/theme'
import Icon from '../icon/theme'
import Image from '../image/theme'
import Input from '../input/theme'
import Label from '../label/theme'
import Link from '../link/theme'
import List from '../list/theme'
import Menu from '../menu/theme'
import Message from '../message/theme'
import Modal from '../modal/theme'
import Notification from '../notification/theme'
import P from '../p/theme'
import Pagination from '../pagination/theme'
import Panel from '../panel/theme'
import Popover from '../popover/theme'
import Progress from '../progress/theme'
import ProgressCircular from '../progressCircular/theme'
import Radio from '../radio/theme'
import Range from '../range/theme'
import Rating from '../rating/theme'
import Select from '../select/theme'
import Sidemenu from '../sidemenu/theme'
import SidemenuV2 from '../sidemenuV2/theme'
import Skeleton from '../skeleton/theme'
import Spinner from '../spinner/theme'
import StepIndicator from '../stepIndicator/theme'
import StepperHorizontal from '../stepperHorizontal/theme'
import StepperVertical from '../stepperVertical/theme'
import Switch from '../switch/theme'
import T from '../t/theme'
import Table from '../table/theme'
import Tabs from '../tabs/theme'
import Tag from '../tag/theme'
import TagToggle from '../tagToggle/theme'
import Textarea from '../textarea/theme'
import Tree from '../tree/theme'
import themePlaceholder from './themePlaceholder'

// Official external components

const Markdown = themePlaceholder
const MarkdownEditor = themePlaceholder

export default {
  Accordion,
  Avatar,
  Badge,
  Box,
  Breadcrumbs,
  Button,
  Calendar,
  Card,
  Chat,
  Checkbox,
  DatePicker,
  Dialog,
  Divider,
  Display,
  DismissButton,
  DragAndDrop,
  Drawer,
  Footer,
  Grid,
  Header,
  Heading,
  Icon,
  Image,
  Input,
  Label,
  Link,
  List,
  Markdown,
  MarkdownEditor,
  Menu,
  Message,
  Modal,
  Notification,
  P,
  Pagination,
  Panel,
  Progress,
  ProgressCircular,
  Definition,
  Popover,
  Radio,
  Range,
  Rating,
  Select,
  Sidemenu,
  Skeleton,
  StepIndicator,
  StepperHorizontal,
  StepperVertical,
  Spinner,
  SidemenuV2,
  Switch,
  T,
  Table,
  Tabs,
  Tag,
  TagToggle,
  Textarea,
  Tree,
}
